import Fire_base from '../../../Config/Fire_base'


const UpdateUserName = async (state) => {
    const currentUser = Fire_base.auth().currentUser
    let setReturn = {}
    if(currentUser){
       await currentUser.updateProfile({
            displayName:state
        }).then((res)=>{
            res=setReturn
        })

        return setReturn
    }
    
}

export default UpdateUserName